import { render, staticRenderFns } from "./wjx_iframe.vue?vue&type=template&id=28c6bfbd&scoped=true"
import script from "./wjx_iframe.vue?vue&type=script&lang=js"
export * from "./wjx_iframe.vue?vue&type=script&lang=js"
import style0 from "./wjx_iframe.vue?vue&type=style&index=0&id=28c6bfbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6bfbd",
  null
  
)

export default component.exports